import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "../i18n";
import Header from "../components/layout/Header.jsx";
import Footer from "../components/layout/Footer.jsx";
import { AltPathProvider } from "../context/AltPathContext.jsx";

const STORAGE_KEY = "preferredLanguage";

export default function LanguageLayout() {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  if (!SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to={`/${DEFAULT_LANGUAGE}/`} replace />;
  }

  useEffect(() => {
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
  }, [lang, i18n]);

  return (
    <AltPathProvider>
      <Header lang={lang} />
      <main>
        <Outlet />
      </main>
      <Footer lang={lang} />
    </AltPathProvider>
  );
}
